<template>
  <a-modal
    class="contact-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :footer="null"
    title="视频信息"
    @cancel="$emit('onCancel')"
  >
    <video
      :src="videoUrl"
      controls
      width="650"
    />
    <form-button
      style="margin-top:20px"
      :show-msg="false"
	  submit-text="确定"
      @onCancel="$emit('onCancel')"
      @onSubmit="$emit('onCancel')"
    />
  </a-modal>
</template>
<script>
export default{
  props: ['visible', 'videoUrl'],
  data(){
    return{

    };
  },
  mounted(){
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>

 </style>